import { Domain as D } from 'auth-common/domain';
import { Const } from 'auth-common/shared';
import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import Project = D.Object.Project;
import Product = D.Object.Product;

export type LatestProductByProjectId = { [K in Project.Id]: Product.Key };
export const latestProductByProjectIdAtom = atomWithStorage<LatestProductByProjectId>(
  Const.LocalStorage.LatestProductByProjectId,
  {},
  undefined,
  {
    getOnInit: true,
  },
);
export const useLatestProductByProjectId = () => {
  const [latestProductByProjectId, setLatestProductByProjectId] = useAtom(latestProductByProjectIdAtom);
  return { latestProductByProjectId, setLatestProductByProjectId };
};
